import { render, staticRenderFns } from "./StockItemRemoveFromGroup.vue?vue&type=template&id=a6d1cec0&scoped=true&"
import script from "./StockItemRemoveFromGroup.vue?vue&type=script&lang=js&"
export * from "./StockItemRemoveFromGroup.vue?vue&type=script&lang=js&"
import style0 from "./StockItemRemoveFromGroup.vue?vue&type=style&index=0&id=a6d1cec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d1cec0",
  null
  
)

export default component.exports